import qs from "qs";
import { CobeeResponse } from "v2/infrastructure/common/types/CobeeResponse";
import { apiInstance } from "v2/infrastructure/common/api/apiClient";
import Request from "v2/domain/benefitRequest/entities/Request";
import restoreBenefitRequests from "../../builders/restoreBenefitRequests";
import IFindBenefitRequestsResponseContent from "../../interfaces/IFindBenefitRequests";

export type FindBenefitRequestsResponse = CobeeResponse<
  IFindBenefitRequestsResponseContent[]
>;

const getBenefitRequests = async ({
  companyId,
  states,
  categories,
}: {
  companyId: string;
  states: string[];
  categories: string[];
}): Promise<Request[]> => {
  const stateParams = qs.stringify(
    { state: states },
    { arrayFormat: "brackets" }
  );
  const categoryParams = qs.stringify(
    { category: categories },
    { arrayFormat: "brackets" }
  );

  const parsedStateParams = stateParams !== "" ? `&${stateParams}` : "";
  const parsedCategoryParams =
    categoryParams !== "" ? `&${categoryParams}` : "";

  const params = `${parsedStateParams}${parsedCategoryParams}`;

  const { data } = await apiInstance.get<FindBenefitRequestsResponse>(
    `/v1/companies/${companyId}/benefit-requests?&sort[]=-createdDate&pageSize=999${params}`,
    {}
  );

  return data.content.map(restoreBenefitRequests);
};

export default getBenefitRequests;
